/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrMessageEvent } from '../../models/dbr-message-event';

export interface BalloonsControllerBalloonsPosSse$Params {
  eventid: string;
}

export function balloonsControllerBalloonsPosSse(http: HttpClient, rootUrl: string, params: BalloonsControllerBalloonsPosSse$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrMessageEvent>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerBalloonsPosSse.PATH, 'get');
  if (params) {
    rb.path('eventid', params.eventid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrMessageEvent>;
    })
  );
}

balloonsControllerBalloonsPosSse.PATH = '/balloons/balloons-pos-sse/{eventid}';
